import React, { type ReactElement, useState } from 'react';

import ReportModal from '../../features/ViolationsReport/components/ReportModal';
import ReportPreview from '../../features/ViolationsReport/components/ReportPreview';

import './Report.css';

/**
 * Layout for the Report page:
 * ECMv6/soddetail/violations/report
 *
 */
function Report(): ReactElement {
  const [showReportModal, setShowReportModal] = useState(false);

  if (showReportModal) {
    return (
      <ReportModal isOpen={showReportModal} setIsOpen={setShowReportModal} />
    );
  }

  return <ReportPreview setShowReportModal={setShowReportModal} />;
}

export default Report;
